// The app bar's leading cluster. The drawer opens over the header and repeats
// this row, so both read these definitions rather than keeping two copies in
// step by hand.
import { IconButton, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { Link } from 'react-router-dom';
import { CONDENSED_STACK, CONTROL_TEXT, HOVER_BG } from '../tokens';

export const MenuIconButton = styled(IconButton)({
  width: '30px',
  height: '30px',
  marginLeft: '-4px',
  padding: 0,
  borderRadius: '5px',
  color: CONTROL_TEXT,
  '& .MuiSvgIcon-root': { fontSize: 18 },
  '&:hover': { backgroundColor: HOVER_BG },
});

export const BrandLink = styled(Link)({
  display: 'flex',
  cursor: 'pointer',
  textDecoration: 'none',
});

// Rendered twice per lockup — coral "Curated", dark "List" — so the two halves
// sit on one baseline with no space between them.
export const BrandTitle = styled(Typography)({
  fontFamily: CONDENSED_STACK,
  fontSize: '18px',
  fontWeight: 800,
  lineHeight: 1,
  letterSpacing: '.005em',
  textTransform: 'uppercase',
});
